<span
  class="d-inline-block p-1 step-circle rounded-circle"
  [class.bg-gray-500]="bgColor === 'gray' && !completed"
  [class.bg-white]="bgColor === 'white'"
  [class.border-dark-green]="borderColor === 'dark-green' && !completed"
  [class.border-success-dark]="completed"
>
  <i class="material-icons-round text-success" [class.invisible]="!completed">done</i>
</span>
